<div class="card">
    <app-header titulo="Grupo Material" descricao="Grupos de materiais integrados"></app-header>

    <p-table [value]="grupos" #dt [loading]="loading">
        <ng-template pTemplate="caption">
            <div class="flex">
                <button pButton pRipple icon="pi pi-refresh" (click)="carregarGrupos()"></button>
                <span class="p-input-icon-left ml-auto">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($any($event.target)?.value, 'contains')" placeholder="Pesquisar" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th>Cód ERP</th>
                <th>Cód PIMS</th>
                <th>Descrição</th>
                <th>Dt Recebido</th>
                <th>Status</th>
                <th>Dt Integrado</th>
                <th>Mensagem</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-grupo>
            <tr>
                <td>{{ grupo.cdGrupoErp }}</td>
                <td>{{ grupo.cdGrupoPims }}</td>
                <td>{{ grupo.deGrupo }}</td>
                <td>{{ grupo.dtRecebido | date: 'dd/MM/yyyy HH:mm' }}</td>
                <td><app-tag-status [status]="grupo.fgStatusInteg"></app-tag-status></td>
                <td>{{ grupo.dtIntegPims | date: 'dd/MM/yyyy HH:mm' }}</td>
                <td>{{ grupo.deMensagemInteg }}</td>
            </tr>
        </ng-template>

    </p-table>
</div>